import React from 'react';
import { Tooltip } from 'react-bootstrap';
import { Bar, BarChart, CartesianGrid, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';

function GroupByAgeDistribution({ title = [] }) {
  const [{ range1, range2, range3 }] = title;
  const data = [
    { name: 'Mayor a 54 años', value: range3 },
    { name: '36 a 54 años', value: range2 },
    { name: '18 a 35 años', value: range1 }
  ];

  return (
    <div className="AgeDistributionGraphic" style={{ width: '100%', height: 125 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 20, right: 30, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tick={{ fontSize: 10 }} />
          <YAxis width={100} dataKey="name" type="category" style={{ fontSize: 10 }} />
          <Tooltip />
          <Bar dataKey="value" fill="#64b5f6">
            <LabelList dataKey="value" position="right" style={{ fontSize: 10 }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default GroupByAgeDistribution;
